<div class="main-div">
    <p class="text-div">Insufficient data to load the page. Try resuming this project from <b>Dashboard</b>.</p>
    <div class="button-div">
        <button mat-flat-button color="warn" class="dashboardButton" (click)="goToDashboard()"> Go To Dashboard</button>
    </div>
</div>